import { useEffect } from 'react';

/**
 * Content Security Policy component to enhance frontend security
 */
export function ContentSecurityPolicy() {
  useEffect(() => {
    // Add CSP meta tag if not already present
    const existingCsp = document.querySelector('meta[http-equiv="Content-Security-Policy"]');
    
    if (!existingCsp) {
      const meta = document.createElement('meta');
      meta.httpEquiv = 'Content-Security-Policy';
      meta.content = [
        "default-src 'self'",
        "script-src 'self' 'unsafe-inline' 'unsafe-eval' https://js.stripe.com https://m.stripe.network https://us-assets.i.posthog.com",
        "style-src 'self' 'unsafe-inline' https://fonts.googleapis.com",
        "font-src 'self' https://fonts.gstatic.com",
        "img-src 'self' data: https: blob:",
        "connect-src 'self' https://zbdgjhhhnlfgsxwxavcj.supabase.co https://api.openai.com https://api.stripe.com https://us.i.posthog.com https://*.amazonaws.com",
        "frame-src 'self' https://js.stripe.com https://hooks.stripe.com https://hcaptcha.com https://newassets.hcaptcha.com https://*.hcaptcha.com",
        "object-src 'none'",
        "base-uri 'self'",
        "form-action 'self'"
      ].join('; ');
      
      document.head.appendChild(meta);
    }

    // Add additional security headers via meta tags
    // Note: X-Frame-Options removed as it should only be set via HTTP headers
    const securityHeaders = [
      { name: 'X-Content-Type-Options', content: 'nosniff' },
      { name: 'X-XSS-Protection', content: '1; mode=block' },
      { name: 'Referrer-Policy', content: 'strict-origin-when-cross-origin' }
    ];

    securityHeaders.forEach(({ name, content }) => {
      const existing = document.querySelector(`meta[http-equiv="${name}"]`);
      if (!existing) {
        const meta = document.createElement('meta');
        meta.httpEquiv = name;
        meta.content = content;
        document.head.appendChild(meta);
      }
    });
  }, []);

  return null;
}

/**
 * Hook to sanitize user-generated content before displaying
 */
export function useSafeContent(content: string): string {
  const sanitizeContent = (input: string): string => {
    if (!input || typeof input !== 'string') return '';
    
    // Create a temporary div to safely parse and clean HTML
    const temp = document.createElement('div');
    temp.textContent = input; // This automatically escapes HTML
    
    // Additional cleaning for common XSS vectors
    return temp.innerHTML
      .replace(/javascript:/gi, '')
      .replace(/on\w+\s*=/gi, '')
      .replace(/<script[^>]*>.*?<\/script>/gi, '');
  };

  return sanitizeContent(content);
}